import { Directive, ElementRef, HostListener, Output, EventEmitter, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ITwoDigitDecimalInput } from './model/CommonModel';

@Directive({
  selector: '[appTwoDigitDecimal]'
})

export class TwoDigitDecimalDirective {
  @Input('appTwoDigitDecimal') integerLength: ITwoDigitDecimalInput;
  @Output() public isFieldDirty = new EventEmitter<any>();

  private regex: RegExp;
  private regexIntLength1: RegExp = new RegExp(/^[0-9]{0,1}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength2: RegExp = new RegExp(/^[0-9]{0,2}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength3: RegExp = new RegExp(/^[0-9]{0,3}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength4: RegExp = new RegExp(/^[0-9]{0,4}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength5: RegExp = new RegExp(/^[0-9]{0,5}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength6: RegExp = new RegExp(/^[0-9]{0,6}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength7: RegExp = new RegExp(/^[0-9]{0,7}(?:[\.][0-9]{0,2})?$/g);
  private regexIntLength15: RegExp = new RegExp(/^[0-9]{0,15}(?:[\.][0-9]{0,2})?$/g);

  private specialKeysSet1: Array<string> = ['Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'F12', 'F1', 'F3', 'F5', 'F6', 'F7',
    'F10', 'F11', 'CapsLock'];
  private specialKeysSet2: Array<string> = ['Backspace', 'Del', 'Delete'];

  get ctrl() {
    return this.ngControl.control;
  }

  constructor(private el: ElementRef,
    private ngControl: NgControl) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    if (this.specialKeysSet1.indexOf(event.key) !== -1) {
      return;
    }
    if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
      return;
    }
    if ((event.ctrlKey || event.metaKey) && event.keyCode == 67) {
      return;
    }
    this.isFieldDirty.emit();
    if (this.specialKeysSet2.indexOf(event.key) !== -1) {
      return;
    }
    this.checkType();
    let tempValue: string;
    let next: string;
    let position = this.el.nativeElement.selectionStart;
    let positionEnd = this.el.nativeElement.selectionEnd;
    if ((this.integerLength.IsCurrency === true) && (this.el.nativeElement.value.match(/[$,]/g))) {
      tempValue = this.el.nativeElement.value.replace(/[$,]/g, '');
      position = position - 1;
      positionEnd = positionEnd - 1;
    } else {
      tempValue = this.el.nativeElement.value;
    }
    next = [tempValue.slice(0, position), event.key == 'Decimal' ? '.' : event.key, tempValue.slice(positionEnd)].join('');
    if (parseFloat(next) > parseFloat(this.integerLength.MaximumValue)) {
      event.preventDefault();
    }
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
    this.isFieldDirty.emit();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    this.isFieldDirty.emit();
    this.el.nativeElement.focus();
    this.checkType();
    let pastedInput: string = event.clipboardData.getData('text/plain');
    if (this.integerLength.IsCurrency === true) {
      pastedInput = pastedInput.replace(/[$,]/g, '');
    }
    let test = false;
    test = this.regex.test(pastedInput);
    if (test === false) {
      event.preventDefault();
    } else if ((parseFloat(pastedInput) < parseFloat(this.integerLength.MinimumValue)) || (parseFloat(pastedInput) > parseFloat(this.integerLength.MaximumValue))) {
      event.preventDefault();
    } else {
      let anyNavigator: any;
      anyNavigator = window.navigator;
      if (anyNavigator.clipboard) {
        anyNavigator.clipboard.writeText(pastedInput);
        document.execCommand('paste');
      }
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    this.isFieldDirty.emit();
    let textData: string = event.dataTransfer.getData('text');
    this.el.nativeElement.focus();
    this.checkType();
    if (this.integerLength.IsCurrency === true) {
      textData = textData.replace(/[$,]/g, '');
    }
    let test = false;
    test = this.regex.test(textData);
    if (test === false) {
      event.preventDefault();
    } else if ((parseFloat(textData) < parseFloat(this.integerLength.MinimumValue)) || (parseFloat(textData) > parseFloat(this.integerLength.MaximumValue))) {
      event.preventDefault();
    } else {
      let anyNavigator: any;
      anyNavigator = window.navigator;
      if (anyNavigator.clipboard) {
        anyNavigator.clipboard.writeText(textData);
        document.execCommand('paste');
      }
    }
  }

  @HostListener("blur") onBlur(value) {
    this.validation();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.validation();
  }

  validation() {
    let tempValue: string;
    if (this.integerLength.IsCurrency === true) {
      tempValue = this.el.nativeElement.value.replace(/[$,]/g, '');
    } else {
      tempValue = this.el.nativeElement.value;
    }
    if ((tempValue === '') || (tempValue === '.')) {
      if ((this.integerLength.DefaultMinimum === true) || (tempValue === '.')) {
        if (this.integerLength.IsCurrency === true) {
          this.el.nativeElement.value = '$' + this.integerLength.MinimumValue;
          this.isFieldDirty.emit('check');
        } else {
          this.el.nativeElement.value = this.integerLength.MinimumValue;
          this.isFieldDirty.emit('check');
        }
      } else {
        if (this.el.nativeElement.value !== tempValue) {
          this.el.nativeElement.value = '';
          this.isFieldDirty.emit('check');
        }
      }
      this.ctrl.setValue(this.el.nativeElement.value);
    } else if ((parseFloat(tempValue) < parseFloat(this.integerLength.MinimumValue)) ||
      (parseFloat(tempValue) > parseFloat(this.integerLength.MaximumValue))) {
      this.mapMinimumOrMaximum(tempValue);
    } else {
      this.valueToFixed(tempValue);
    }
  }

  mapMinimumOrMaximum(tempValue) {
    if (parseFloat(tempValue) < parseFloat(this.integerLength.MinimumValue)) {
      this.el.nativeElement.value = this.integerLength.MinimumValue;
    } else if (parseFloat(tempValue) > parseFloat(this.integerLength.MaximumValue)) {
      this.el.nativeElement.value = this.integerLength.MaximumValue;
    }
    if (this.integerLength.IsCurrency === true) {
      this.el.nativeElement.value = '$' + this.el.nativeElement.value;
    }
    this.ctrl.setValue(this.el.nativeElement.value);
    this.isFieldDirty.emit('check');
  }

  valueToFixed(tempValue) {
    const newValue: string = this.el.nativeElement.value;
    if (this.integerLength.WholeValue == true) {
      this.ctrl.setValue(this.el.nativeElement.value);
    } else if (this.integerLength.IsCurrency === true) {
      if (tempValue !== '') {
        if (newValue !== '$' + parseFloat(tempValue).toFixed(2)) {
          this.el.nativeElement.value = '$' + parseFloat(tempValue).toFixed(2);
          this.ctrl.setValue(this.el.nativeElement.value);
          this.isFieldDirty.emit('check');
        }
      }
    } else {
      if (tempValue !== '') {
        if (newValue !== parseFloat(tempValue).toFixed(2)) {
          this.el.nativeElement.value = parseFloat(tempValue).toFixed(2);
          this.ctrl.setValue(this.el.nativeElement.value);
          this.isFieldDirty.emit('check');
        }
      }
    }
  }

  checkType() {
    switch (this.integerLength.Length) {
      case (1): this.regex = this.regexIntLength1;
        break;
      case (2): this.regex = this.regexIntLength2;
        break;
      case (3): this.regex = this.regexIntLength3;
        break;
      case (4): this.regex = this.regexIntLength4;
        break;
      case (5): this.regex = this.regexIntLength5;
        break;
      case (6): this.regex = this.regexIntLength6;
        break;
      case (7): this.regex = this.regexIntLength7;
        break;
      case (15): this.regex = this.regexIntLength15;
        break;
      default: this.regex = this.regexIntLength6;
        break;
    }
  }
}
